























import Vue from 'vue'
import InputZone from './InputZone/InputZone.vue'
import MessageArea from './MessageArea/MessageArea.vue'
import TopZone from './TopZone/TopZone.vue'

export default Vue.extend({
  components: {
    appTopZone: TopZone,
    appInputZone: InputZone,
    appMessagesArea: MessageArea,
  },
  props: {
    value: Boolean,
    poster: Function,
    messages: Array,
  },
  data() {
    return {
      scrolled: false,
    }
  },
  computed: {
    isMobile(): boolean {
      return this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    async scrollBottom() {
      const list = this.$refs.scroll as HTMLElement
      if (list) {
        await this.$nextTick()
        list.scrollTo({
          behavior: 'smooth',
          top: list.scrollHeight,
        })
      }
    },
    onNewMessage(message: string) {
      this.messages.unshift(message)
      this.scrollBottom()
    },
  },
  watch: {
    value(value: boolean) {
      if (value && !this.scrolled) {
        this.scrollBottom()
        setTimeout(async () => {
          this.scrollBottom()
        }, 500)
      }
    },
  },
})
